module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ScoreJianluList', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "broadcast": _vm.row.jianlu_broadcast,
      "start-id": _vm.$route.query.start_id
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ab79ca2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/JianluShow.vue
// module id = 2490
// module chunks = 0